import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { ServiciosService } from './servicios.service';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Rx';
import { query } from '@angular/core/src/animation/dsl';
import { EdicionCotizacion } from '../models/edicionCotizacion';
import { FirebaseApp } from 'angularfire2';
import 'firebase/storage';
import { arregloDePuntosIntermedios } from '../shared/pipes/arreglo-puntos-intermedios.pipe';
import {forEach} from "@angular/router/src/utils/collection";
import {_throw} from 'rxjs/observable/throw';

// UID del pseudo-usuario "Página Web" con el que se crean las cotizaciones web
// (definido en trosten-corp-school/PHP/admin/PaginaWeb/crearCotizacionWeb.php como CPW_USUARIO_KEY).
// Toda cotización cuyo usuarioQueCotizo sea este valor está pendiente de asignación a un agente real.
// Si ese valor cambiara en el endpoint PHP, hay que actualizarlo también aquí.
export const CPW_USUARIO_KEY = 'r5idQ41qz9gXttDaf2RV2CL4Z313';

// Cliente genérico "Cotizaciones Página Web" (CPW_CLIENTE_KEY). Desde TOM-359 sólo se usa como
// fallback cuando HubSpot no está disponible al crear la cotización; las cotizaciones bajo este
// cliente NO representan un cliente recurrente real, por lo que se excluyen de la sugerencia de
// agente habitual.
export const CPW_CLIENTE_KEY = '-N80WXGNGx07bHO3XDcv';

// La cuenta CPW acumula históricamente TODAS las cotizaciones web sin asignar (decenas de miles),
// porque hasta ahora nunca se reasignaban. La mayoría es ruido del flujo viejo de la página web y
// de leads sin validación de HubSpot (que quedan bajo el cliente genérico CPW_CLIENTE_KEY). Sólo
// interesan las creadas por el endpoint nuevo (TOM-358/359) que SÍ resolvieron un cliente real de
// HubSpot, es decir cliente !== CPW_CLIENTE_KEY. Por eso se escanean las más recientes y luego se
// filtran por cliente real (ver componente). Ambos números son ajustables según ventas.
// FETCH: cuántos nodos recientes de la cuenta CPW se traen para filtrar.
export const PENDIENTES_ASIGNACION_FETCH = 200;
// MAX: cuántas filas ya validadas se muestran/enriquecen como máximo.
export const PENDIENTES_ASIGNACION_MAX = 50;

// Allowlist fija para el dropdown de asignación (TOM-390 — siglas proporcionadas por Ro en la
// junta semanal 2026-08-12). Se usa un mapa fijo uid -> siglas en vez de derivarlo de
// informacionLaboral/departamento === 'Ventas' porque ese campo NO es una señal confiable: AGM y
// RVQ están guardados en RTDB con departamento 'Admin' aunque cotizan activamente como agentes de
// Ventas (confirmado contra cotizaciones/servicios reales -- sus idTrosten/idConfirmacion son
// CTAGM-…/VIAGM-…/CTRVQ-…). Las siglas son las mismas que arma ServicioGenerarId al crear un
// idTrosten (nombre[0]+apellidoPaterno[0]+apellidoMaterno[0]), NO el campo
// informacionPersonal.siglas, que está incompleto e inconsistente (ej. "MFPE" guardado vs "MPE" real).
export const AGENTES_ASIGNABLES: {[uid: string]: string} = {
    'BGPpum4PxHT4mrUaFDAKzjM6b0h1': 'AAA',
    'kTuQOK2N6yY4Zb2BHzeya3jFuT52': 'AGM',
    'QTrvGOAVqmbgtihNAykY1tyzuzC2': 'COR',
    'flGjuvlwCkPgNC8CkfhBRzQLaCf2': 'JVA',
    'cR6SSE7dfnWhdv4hr6NwLpLYzLv2': 'MNF',
    'rqGLNkMdqdTKD8jF7whABOS1d6I3': 'MPE',
    'PWbWBv3BDuOnNW2I0BL3MYV95dI3': 'PZS',
    'xhSKdJ65FWTDiNv7XU8r5Cftyx32': 'RVQ',
};

export function esAgenteAsignable(uid: string): boolean {
    return !!uid && AGENTES_ASIGNABLES.hasOwnProperty(uid);
}

@Injectable()
export class CotizacionesService{
    firebaseStorage:any;
    // DÃ­as en Milisegundos
    private diaEnMilis:number = 1000 * 60 * 60 * 24;

    constructor (
        private afDB: AngularFireDatabase,
        private afs: AngularFirestore,
        private serviciosService: ServiciosService,
        private firebaseApp:FirebaseApp,
        private http:HttpClient){
            this.firebaseStorage = firebaseApp.storage().ref()

    }

    /**
     * Crea una cotizaciÃ³n nueva
     * @param cotizacion
     * @param servicios
     * @param contadorCotizaciones
     */
    public insertarCotizacionNuevaTabla(key_cotizacion,data_cotizacion,tabla) {

        let multipathUpdate = {};
        multipathUpdate['/cotizaciones'+tabla+'/' + key_cotizacion] = data_cotizacion;
        multipathUpdate['/cotizacionesPorUsuario'+tabla+'/' + data_cotizacion['usuarioQueCotizo'] + '/' + key_cotizacion] = data_cotizacion;

        return Promise.all([this.afDB.object('/').update(multipathUpdate), key_cotizacion]);
    }

    public crearCotizacion(cotizacion, servicios, contadorCotizaciones, descuentoAGuardarAdicional,descuentoAGuardarMark,descuentoAGuardarAdmin,totalConDescuentos) {
        // Asigna los estatus iniciales de la cotizaciÃ³n
        cotizacion['estatus'] = 'Realizada';
        cotizacion['fechaDeCreacion'] = Date.now();
        cotizacion['fueEnviada'] = false;
        cotizacion['fueLeida'] = false;
        cotizacion['numeroDeEdiciones'] = 0;
        cotizacion['servicios'] = this.serviciosService.configurarServiciosParaCreacion(servicios);

        cotizacion['descuentoAGuardarAdicional'] = descuentoAGuardarAdicional;
        cotizacion['descuentoAGuardarMark'] = descuentoAGuardarMark;
        cotizacion['descuentoAGuardarAdmin'] = descuentoAGuardarAdmin;
        cotizacion['totalConDescuentos'] = totalConDescuentos;

        // Elimina el nodo de referencia de empleado si es que no existe
        if(!cotizacion['referenciaDeEmpleado'])
            delete cotizacion['referenciaDeEmpleado'];
            // Crea un key de firebase
        let firebaseKey = this.afDB.createPushId();
        let multipathUpdate = {};
        multipathUpdate['/cotizaciones/' + firebaseKey] = cotizacion;
        multipathUpdate['/cotizacionesPorUsuario/' + cotizacion['usuarioQueCotizo'] + '/' + firebaseKey] = cotizacion;
        multipathUpdate['/contadores/numeroCotizaciones'] = contadorCotizaciones;

        let batch = this.afs.firestore.batch();
        batch.set(this.afs.firestore.collection('cotizaciones').doc(firebaseKey),cotizacion);
        //batch.set(this.afs.firestore.collection('cotizacionesPorUsuario/'+ cotizacion['usuarioQueCotizo']).doc(firebaseKey),cotizacion);

        let promiseFirestore = this.afDB.object('/').update(multipathUpdate);
        let promiseRealtimeDB = batch.commit();

        return Promise.all([promiseFirestore, firebaseKey,promiseRealtimeDB]);
    }

    public getInfoTicketHubSpot(ticketId)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'ticketId='+ticketId

        return this.http.post('https://operacion.trosten.com/hubspot-service/Ticket/getTicketById.php', body,{headers})
            .catch(errorResponse => {
            let errMsg: string;
            if (errorResponse instanceof HttpErrorResponse) {
                const err = errorResponse.message || JSON.stringify(errorResponse.error);
                errMsg = `${errorResponse.status} - ${errorResponse.statusText || ''} Details: ${err}`;
            } else {
                errMsg = errorResponse.message ? errorResponse.message : errorResponse.toString();
            }
            console.log("errMsg", errMsg)
            return []
        });;
    }

    public getInfoContactoHubSpot(contactId)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'contactId='+contactId

        return this.http.post('https://operacion.trosten.com/hubspot-service/Contacto/getContactoById.php', body,{headers})
            .catch(errorResponse => {
                let errMsg: string;
                if (errorResponse instanceof HttpErrorResponse) {
                    const err = errorResponse.message || JSON.stringify(errorResponse.error);
                    errMsg = `${errorResponse.status} - ${errorResponse.statusText || ''} Details: ${err}`;
                } else {
                    errMsg = errorResponse.message ? errorResponse.message : errorResponse.toString();
                }
                console.log("errMsg", errMsg)
                return []
            });;
    }

    public updateCotizacionLeidaHubSpot(idNegocioHubspot)
    {
        var dateFinServicio = new Date()
                    dateFinServicio.setHours(0);
                    dateFinServicio.setMinutes(0)
        var finDeServicioFecha = (dateFinServicio).toISOString();
        var forcedMidnighFinDeServicioFecha = finDeServicioFecha.replace(finDeServicioFecha.substring(finDeServicioFecha.indexOf('T'), finDeServicioFecha.lastIndexOf(':00:')), 'T00');

        console.log("forcedMidnighFinDeServicioFecha", forcedMidnighFinDeServicioFecha)
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        var dealstage = 19311255;
        var pipeline = 6424872;
        const body = 'dealId='+idNegocioHubspot+
            '&dealstage='+dealstage+
            '&pipeline='+pipeline+
            '&fecha_leida='+forcedMidnighFinDeServicioFecha;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioLeido.php', body,{headers});

    }
    public updateCotizacionUltimaVezLeidaHubSpot(idNegocioHubspot)
    {
        var dateFinServicio = new Date()
                    dateFinServicio.setHours(0);
                    dateFinServicio.setMinutes(0)
        var finDeServicioFecha = (dateFinServicio).toISOString();
        var forcedMidnighFinDeServicioFecha = finDeServicioFecha.replace(finDeServicioFecha.substring(finDeServicioFecha.indexOf('T'), finDeServicioFecha.lastIndexOf(':00:')), 'T00');

        console.log("forcedMidnighFinDeServicioFecha", forcedMidnighFinDeServicioFecha)
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'dealId='+idNegocioHubspot+
            '&fecha_leida='+forcedMidnighFinDeServicioFecha;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/updateNegocioUltimaVezCotiLeido.php', body,{headers});

    }

    

    public getNegocioHubSpot (idNegocioHubspot)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'dealId='+idNegocioHubspot;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/getNegocioById.php', body,{headers});

    }

    public asociarNegocioHubspot (idNegocio, idContacto)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'dealId=' + idNegocio +
            '&toObjectId='+idContacto;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Associations/asociarNegocioConContacto.php', body,{headers});
    }

    public asociarNegocioEmpresaHubspot (idNegocio, idEmpresa)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'dealId=' + idNegocio +
            '&toObjectId='+idEmpresa;

        return this.http.post('https://operacion.trosten.com/hubspot-service/Associations/asociarNegocioConEmpresa.php', body,{headers});
    }


    public crearCotizacionHubSpot(key_cotizacion, cotizacion, idVentasHubspot, total,inicioDeServicioFecha,finDeServicioFecha,info_servicio,infoCliente)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        var createdate = (new Date()).toISOString();
        var dealname = cotizacion["idTrosten"]+ " / " + infoCliente.nombreCliente;
        var link_de_cotizacion = 'www.operacion.trosten.com/#/cotizacion/'+key_cotizacion
        var dealstage = 19311254;
        var hubspot_owner_id = idVentasHubspot;
        var pipeline = 6424872;
        var fecha_de_viaje = inicioDeServicioFecha;

        const siglas_agente = cotizacion['idTrosten'].substring(2, 5).toUpperCase();

        const origen_alias_aux = info_servicio["origen"]["alias"].replace(/"/g,"'")
        const destino_alias_aux = info_servicio["destino"]["alias"].replace(/"/g,"'")
        const origen_dir_aux = info_servicio["origen"]["direccion"].replace(/"/g,"'")
        const destino_dir_aux = info_servicio["destino"]["direccion"].replace(/"/g,"'")

        const origenNormalized = origen_alias_aux.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + ". "+origen_dir_aux.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        const destinoNormalized = destino_alias_aux.normalize("NFD").replace(/[\u0300-\u036f]/g, "") + ". "+destino_dir_aux.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        const origen = origenNormalized ;
        const destino = destinoNormalized ;
        const fecha_de_fin = finDeServicioFecha;
        const fecha_de_inicio = inicioDeServicioFecha;
        const id_cotizacion = cotizacion["idTrosten"];
        const linea_de_negocio = cotizacion["tipoDeVenta"];
        const de_donde_llego = infoCliente.metodoDeCotizacion;
        const metodo_de_cotizacion = cotizacion["metodoDeCotizacion"];
        const notas_al_cliente = info_servicio["indicacionesEspeciales"];
        const notas_al_operador = info_servicio["notas"];
        const tipo_cliente = infoCliente.tipoCliente || 'No Especificado';
        const punto_origen = infoCliente.puntoOrigen || '';
        const tipo_de_servicio = info_servicio["tipoDeViaje"] || '';

        var tipo_unidad_aux = ''

        try{
            for(let indexPrecioCombinaciones in info_servicio["precioCombinaciones"]){
                for(let indiceCamionetas in info_servicio["precioCombinaciones"][indexPrecioCombinaciones].combinacion){
                    if(info_servicio["precioCombinaciones"][indexPrecioCombinaciones].combinacion[indiceCamionetas] > 0)
                    tipo_unidad_aux += indiceCamionetas+", "
                }
            }
        }catch(e)
        {
            console.log("error",e)
        }
        

        var tipoDeUnidad = ""
        if(tipo_unidad_aux.length > 0)
        tipoDeUnidad = tipo_unidad_aux.substring(0, tipo_unidad_aux.length - 2);

        const body = 'amount=' + total +
            '&destino='+destino+
            '&fecha_de_fin='+fecha_de_fin+
            '&fecha_de_inicio='+fecha_de_inicio+
            '&id_cotizacion='+id_cotizacion+
            '&linea_de_negocio='+linea_de_negocio+
            '&de_donde_llego='+de_donde_llego+
            '&metodo_de_cotizacion='+metodo_de_cotizacion+
            '&notas_al_cliente='+notas_al_cliente+
            '&notas_al_operador='+notas_al_operador+
            '&origen='+origen+
            '&fecha_de_viaje='+fecha_de_viaje+
            '&createdate='+createdate+
            '&dealname='+dealname+
            '&dealstage='+dealstage+
            '&hubspot_owner_id='+ hubspot_owner_id +
            '&link_de_cotizacion='+link_de_cotizacion+
            '&tipo_de_unidad='+tipoDeUnidad+
            '&tipo_cliente='+tipo_cliente+
            '&siglas_agente='+siglas_agente+
            '&punto_origen='+punto_origen+
            '&tipo_de_servicio='+tipo_de_servicio+
            '&pipeline='+pipeline;

        const body_scaped = body.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\x20-\x7E]/gmi, "")

        return this.http.post('https://operacion.trosten.com/hubspot-service/Negocio/crearNegocio.php', body_scaped,{headers});

    }

    /**
     * Actualiza solamente los servicios de la cotizaciÃ³n e incrementa el numero de ediciones realizadas
     * @param idCotizacion Id de la cotizaciÃ³n por actualizar
     * @param cotizacion objeto completo de cotizaciÃ³n
     * @param servicios  Arreglo de servicios validados
     * @param edicion Objeto que contiene el usuario
     */
    public editarServicios(idCotizacion:string, cotizacion:any, servicios:Array<any>, edicion:EdicionCotizacion):Promise<any> {
        // Incrementa el numero de ediciones hechas en la cotizacion
        let multipath = {};
        let numeroDeEdiciones = cotizacion.numeroDeEdiciones += 1;
        multipath[`cotizaciones/${idCotizacion}/numeroDeEdiciones/`] = numeroDeEdiciones;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/numeroDeEdiciones/`] = numeroDeEdiciones;

        // Actualiza las banderas de enviada y leida por el cliente, al igual que los contactos notificados
        multipath[`cotizaciones/${idCotizacion}/fueEnviada/`] = false;
        multipath[`cotizaciones/${idCotizacion}/fueLeida/`] = false;
        multipath[`cotizaciones/${idCotizacion}/contactosNotificados/`] = null;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/fueEnviada/`] = false;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/fueLeida/`] = false;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/contactosNotificados/`] = null;

        // Crea el nuevo objeto de servicios
        let objServicios = this.serviciosService.configurarServiciosParaCreacion(servicios);
        multipath[`cotizaciones/${idCotizacion}/servicios/`] = objServicios;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/servicios/`] = objServicios;

        // Coloca el objeto de ediciÃ³n dentro de la cotizaciÃ³n
        let firebaseKeyEdicion = this.afDB.createPushId();
        multipath[`cotizaciones/${idCotizacion}/ediciones/${firebaseKeyEdicion}`] = edicion;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/ediciones/${firebaseKeyEdicion}`] = edicion;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{fueEnviada:false})
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{fueLeida:false})
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{contactosNotificados:null})
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{servicios:objServicios})
        //batch.set(this.afs.firestore.collection('cotizacionesPorUsuario/'+ cotizacion['usuarioQueCotizo']).doc(firebaseKey),cotizacion);

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    public editarTipoDeViajeCotizacionesPaginaWeb(idCotizacion:string, cotizacion:any, servicios):Promise<any> {
        // Incrementa el numero de ediciones hechas en la cotizacion
        let multipath = {};
        multipath[`cotizaciones/${idCotizacion}/servicios/`] = servicios;
        multipath[`cotizacionesPorUsuario/${cotizacion.usuarioQueCotizo}/${idCotizacion}/servicios/`] = servicios;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{servicios:servicios})

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    /**
     * Obtiene todas las cotizaciones
     */
    public encontrarCotizacion(idTrosten){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('idTrosten').equalTo(idTrosten));
    }

    public obtenerTodasLasCotizacionesPorTabla(tabla){
        return this.afDB.list('/cotizaciones'+tabla+'/', ref => ref.orderByChild('fechaDeCreacion'));
    }
    public obtenerTodasLasCotizaciones(){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('fechaDeCreacion'));
    }
    public obtenerCotizacionesEntreFEchas(fechaInicio, fechaFin){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('fechaDeCreacion').startAt(fechaInicio).endAt(fechaFin));
    }
    public obtenerCotizacionesEntreFEchasPorAgente(fechaInicio, fechaFin,agente){
        return this.afDB.list('/cotizacionesPorUsuario/'+agente+'/', ref => ref.orderByChild('fechaDeCreacion').startAt(fechaInicio).endAt(fechaFin));
    }
    /**
     * Redondea un numero a su mÃºltiplo mÃ¡s cercano hacia "Arriba"
     * @param numero
     */
    redondear(numero:number):number{
        const multiplo = 50;
        let diferencia = numero % multiplo;
        return numero + multiplo - diferencia;
    }

    /**
     * Convierte un objeto de cotizaciÃ³n y sus servicios a que
     * utilicen arreglos en lugar de objetos para que sea mÃ¡s sencillo de manipular
     * @param cotizacion el objeto tal cual se obtiene de firebase
     */
    public darFormatoDeArreglos(cotizacion:any):any{
        // Genera un arreglo de servicios
        let servicios = [];
        for (let idServicio in cotizacion.servicios) {
            cotizacion.servicios[idServicio]['$key'] = idServicio;
            servicios.push(cotizacion.servicios[idServicio]);

            //  Genera un arreglo de conceptos adicionales y los agrega al objeto de cotizacion
            let conceptosAdicionales = [];
            for (let idConcepto in cotizacion.servicios[idServicio].conceptosAdicionales){
                cotizacion.servicios[idServicio].conceptosAdicionales[idConcepto]['$key'] = idConcepto;
                conceptosAdicionales.push(cotizacion.servicios[idServicio].conceptosAdicionales[idConcepto]);
            }
            cotizacion.servicios[idServicio].conceptosAdicionales = conceptosAdicionales;
        }
        cotizacion.serviciosArreglo = servicios;

        // Revisa que existan ediciones dentro del servicio y las acomoda como arreglos
        if (cotizacion.hasOwnProperty('ediciones') && cotizacion.numeroDeEdiciones > 0) {
            let ediciones = [];
            for (let idEdicion in cotizacion.ediciones) {
                ediciones.push(cotizacion.ediciones[idEdicion]);
            }
            cotizacion.ediciones = ediciones;
        }

        return cotizacion;
    }

    EstaEntreFechasNumero(fecha:any, fechaInicio:any, fechaFin:any):any{
       if(typeof fechaInicio == 'string'){
        fechaInicio = new Date(fechaInicio).getTime()
       }
       if(typeof fechaFin == 'string'){
        fechaFin = new Date(fechaFin).getTime()
       }
        if(fecha >= fechaInicio && fecha <= fechaFin){
            return true;
        }else{
            return false;
        }

    }

    // Obtiene el objeto cotizaciÃ³n
    public obtenerCotizacion(idCotizacion){
        return this.afDB.object('/cotizaciones/' + idCotizacion + '/');
    }

    /**
     * Marca una cotizaicÃ³n realizada como posible
     * @param cotizacion Objeto de la cotizaciÃ³n que se va a marcar como posible
     * @param fechaPactadaDePago La fecha debe de venir en timestamp
     * @param combinaciones Objeto que lleva las combinaciones seleccionadas por el cliente
     * @param usuario Contiene el UID del usuario que estÃ¡ marcando la cotizaciÃ³n posible
     */
    public marcarCotizacionPosible(cotizacion:any, fechaPactadaDePago:number, combinaciones:any, usuario:string){
        // Arrelgo de viajes posbiles
        let viajesPosibles = [];

        // Arma los objetos de servicios que se van a colocar como posibles
        for(let idServicio in combinaciones){
            viajesPosibles.push(this.serviciosService.configurarServicioPosbile(cotizacion, idServicio, combinaciones, usuario));
        }

        let multipathUpdateCotizacionPosible = {};

        // Genera el estatus en la cotizaciÃ³n con una fecha pactada de pago
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/estatus/'] = 'Posible';
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/estatus/'] = 'Posible';
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/fechaPactadaDePago/'] = fechaPactadaDePago;
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/fechaPactadaDePago/'] = fechaPactadaDePago;
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/combinacionesPosibles/'] = combinaciones;
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/combinacionesPosibles/'] = combinaciones;
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/fueEnviada/'] = true;
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/fueEnviada/'] = true;
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/fueLeida/'] = true;
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/fueLeida/'] = true;
        multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/usuarioQueConfirmo/'] = usuario;
        multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/usuarioQueConfirmo/'] = usuario;

        // Introduce los servicios posibles al multipath
        let batch = this.afs.firestore.batch();
        viajesPosibles.forEach(viaje => {
            let firebaseKey = this.afs.createId();
            batch.set(this.afs.firestore.collection('servicios').doc(firebaseKey), viaje);
            multipathUpdateCotizacionPosible['cotizaciones/' + cotizacion.$key + '/serviciosPosibles/' + firebaseKey + '/'] = true;
            multipathUpdateCotizacionPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/serviciosPosibles/' + firebaseKey + '/'] = true;
        });

        // Se Juntan las Promises de ambas bases de datos
        let promiseRealtimeDB = this.afDB.object('/').update(multipathUpdateCotizacionPosible);
        let promiseFirestore = batch.commit();
        return Promise.all([promiseRealtimeDB, promiseFirestore]);
    }

    /**
     * Elimina el estatus de "Posible" de una cotizaciÃ³n creada
     * @param cotizacion Objeto completo de la cotizacÃ³n que se va a marcar como posible
     * @return Regresa una promise vacÃ­a despuÃ©s de haber realizado un "Multipath Update"
     */
    public revivirCotizacionCancelada(cotizacion: any) {
        const multipathUpdate: { [key: string]: any } = {};
        multipathUpdate['cotizaciones/' + cotizacion.$key + '/estatus/'] = 'Realizada';
        multipathUpdate['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/estatus/'] = 'Realizada';
        return this.afDB.object('/').update(multipathUpdate);
    }

    public eliminarEstatusPosible(cotizacion:any){
        let multipathUpdateQuitarPosible = {};

        multipathUpdateQuitarPosible['cotizaciones/' + cotizacion.$key + '/estatus/'] = 'Realizada';
        multipathUpdateQuitarPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/estatus/'] = 'Realizada';
        multipathUpdateQuitarPosible['cotizaciones/' + cotizacion.$key + '/fechaPactadaDePago/'] = null;
        multipathUpdateQuitarPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/fechaPactadaDePago/'] = null;
        multipathUpdateQuitarPosible['cotizaciones/' + cotizacion.$key + '/serviciosPosibles/'] = null;
        multipathUpdateQuitarPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/serviciosPosibles/'] = null;
        multipathUpdateQuitarPosible['cotizaciones/' + cotizacion.$key + '/combinacionesPosibles/'] = null;
        multipathUpdateQuitarPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/combinacionesPosibles/'] = null;
        multipathUpdateQuitarPosible['cotizaciones/' + cotizacion.$key + '/usuarioQueConfirmo/'] = null;
        multipathUpdateQuitarPosible['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/usuarioQueConfirmo/'] = null;

        // Elimina los servicios posibles
        let batch = this.afs.firestore.batch();
        for(let idViaje in cotizacion.serviciosPosibles){
            batch.delete(this.afs.firestore.collection('servicios').doc(idViaje));
        }

        // Se juntan las promises de ambas bases de datos
        let promiseRealtimeDB = this.afDB.object('/').update(multipathUpdateQuitarPosible);
        let promiseFirestore = batch.commit();
        return Promise.all([promiseRealtimeDB, promiseFirestore]);
    }

    /**
     * Obtiene las Ãºltimas cotizaciones no leidas por el cliente
     * @param uid Id del usuario del cual se quieren las cotizaciones
     */
    public obtenerCotizacionesNoLeidas(uid?:string){
        // Checa si se requieren de un usuario en especÃ­fico o en general de todos los usuarios
        if(uid)
            return this.afDB.list('/cotizacionesPorUsuario/' + uid + '/', ref => ref.orderByChild('fueLeida').equalTo(false).limitToLast(50));
        else
            return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('fueLeida').equalTo(false).limitToLast(50));
    }

    /**
     * Obtiene las Ãºltimas cotizaciones posibles del usuario
     * @param uid Id del usuario del cual se quieren las cotizaciones
     */
    public obtenerUltimasCotizacionesPosibles(uid?:string){
        // Checa si se requieren de un usuario en especÃ­fico o en general de todos los usuarios
        if(uid)
            return this.afDB.list('/cotizacionesPorUsuario/' + uid + '/', ref => ref.orderByChild('estatus').equalTo('Posible').limitToLast(50));
        else
            return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('estatus').equalTo('Posible').limitToLast(50));
    }

    /**
     * Obtiene las cotizaciones por 1 cliente
     * @param idCliente
     */
    public obtenerCotizacionesPorCliente(idCliente:string){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('cliente').equalTo(idCliente));
    }
    public obtenerCotizacionesPorIdTrosten(idTrosten:string){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('idTrosten').equalTo(idTrosten));
    }

    public obtenerCotizacionesPorKeyAgente(keyAgente:string){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('usuarioQueCotizo').equalTo(keyAgente));
    }

    /**
     * Obtiene las cotizaciones web pendientes de asignación: las que siguen atribuidas al
     * pseudo-usuario "Página Web" (usuarioQueCotizo === CPW_USUARIO_KEY).
     */
    public obtenerCotizacionesPendientesAsignacion(limite: number = PENDIENTES_ASIGNACION_FETCH){
        return this.afDB.list('/cotizacionesPorUsuario/' + CPW_USUARIO_KEY + '/',
            ref => ref.orderByChild('fechaDeCreacion').limitToLast(limite));
    }

    /**
     * Reasigna una cotización web desde el pseudo-usuario "Página Web" hacia un agente real.
     * La cotización está denormalizada (existe en cotizaciones/{id} y en
     * cotizacionesPorUsuario/{uid}/{id}), por lo que NO basta con reescribir un campo: hay que
     * mover el nodo completo en una sola operación atómica:
     *   1. copia el nodo completo a cotizacionesPorUsuario/{nuevoUid}/{id} con usuarioQueCotizo = nuevoUid
     *   2. elimina el nodo bajo cotizacionesPorUsuario/{CPW_USUARIO_KEY}/{id}
     *   3. actualiza cotizaciones/{id}/usuarioQueCotizo = nuevoUid
     *   4. espeja usuarioQueCotizo en el documento Firestore cotizaciones/{id}
     * Sigue la misma disciplina de escritura RTDB + Firestore que editarIdNegocioHubspot.
     */
    public asignarCotizacionAAgente(idCotizacion:string, data_cotizacion:any, nuevoUid:string):Promise<any> {
        // Refuerzo en la escritura (TOM-390): el dropdown ya sólo ofrece agentes de la allowlist,
        // pero se rechaza aquí también por si el modelo llega con un uid fuera de lista (atajo
        // "agente habitual" u otro camino).
        if (!esAgenteAsignable(nuevoUid)) {
            return Promise.reject({ codigo: 'AGENTE_NO_ASIGNABLE' });
        }

        // Relee el dueño actual justo antes de mover. Si otra persona ya asignó esta cotización
        // (dos usuarios con la misma fila cargada), el dueño ya no será el pseudo-usuario web; en
        // ese caso se rechaza para no dejar copias duplicadas bajo distintos agentes.
        return this.afDB.object('cotizaciones/' + idCotizacion + '/usuarioQueCotizo')
            .snapshotChanges().take(1).toPromise()
            .then(snap => {
                const duenoActual = snap.payload.val();
                if (duenoActual !== CPW_USUARIO_KEY) {
                    return Promise.reject({ codigo: 'YA_ASIGNADA', duenoActual: duenoActual });
                }

                let nodoReasignado = Object.assign({}, data_cotizacion);
                nodoReasignado.usuarioQueCotizo = nuevoUid;
                // $key es un campo auxiliar que agrega el componente; no debe persistirse en el nodo.
                delete nodoReasignado.$key;

                let multipath:any = {};
                multipath['cotizacionesPorUsuario/' + nuevoUid + '/' + idCotizacion + '/'] = nodoReasignado;
                multipath['cotizacionesPorUsuario/' + CPW_USUARIO_KEY + '/' + idCotizacion + '/'] = null;
                multipath['cotizaciones/' + idCotizacion + '/usuarioQueCotizo/'] = nuevoUid;

                let batch = this.afs.firestore.batch();
                batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion), {usuarioQueCotizo: nuevoUid});

                let promiseRealtimeDB = this.afDB.object('/').update(multipath);
                let promiseFirestore = batch.commit();

                return Promise.all([promiseRealtimeDB, promiseFirestore]);
            });
    }

    public obtenerCotizacionesPorUsuario(keyAgente:string,tabla:string){
        return this.afDB.list('/cotizacionesPorUsuario'+tabla+'/'+keyAgente);
    }

    public obtenerCotizacionesPorIDTrosten(idTrosten:string){
        console.log("idTrosten",idTrosten)
        return this.afs.collection('cotizaciones',ref => ref.where('idTrosten','==',idTrosten));
    }

    public obtenerCotizacionesSinFechaDeCreacion(keyAgente:string){
        return this.afDB.list('/cotizaciones/', ref => ref.orderByChild('fechaCreacion').equalTo(undefined));
    }

    /**
     * EnvÃ­a la lia de la cotizaciÃ³n al cliente
     * @param cotizacion
     * @param cliente
     */
    public enviarCotizacionCliente(cotizacion:any, contacto:any,cliente:any){
        /*
        let servicios_arr= [];
        console.log(cotizacion)
        for (var idServicio in cotizacion.servicios) {
            servicios_arr.push(cotizacion.servicios[idServicio])
        }

        let precio = 0;
        let tipo_unidad = "";
        let num_unidades = "";
        let combinaciones =[];
        let conceptosAdicionales = [];

        conceptosAdicionales = servicios_arr[0].conceptosAdicionales;

        let serv = servicios_arr[0];
        for (const keyUnidad in serv.costoCombinaciones) {
            if (serv.costoCombinaciones.hasOwnProperty(keyUnidad)) {
                const unidad = serv.costoCombinaciones[keyUnidad];
                for (const indiceUnidad in unidad) {
                    if (unidad.hasOwnProperty(indiceUnidad)) {
                        const res = unidad[indiceUnidad];

                        precio = Math.round(serv['precioCombinaciones'][keyUnidad])
                        tipo_unidad = indiceUnidad;
                        num_unidades = res.numeroDeUnidades + "Unidad(es) "+ indiceUnidad;

                        combinaciones.push({t:indiceUnidad,n:num_unidades,p:'Unidad '+indiceUnidad+": $"+(precio).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')});
                    }
                }
            }
        }

        let url = "http://app.trosten.com/pdf-service/cotizacion-pdf-check-vista.php?id="+cotizacion.idTrosten +
            "&o="+serv.origen.alias+
            "&d="+serv.destino.alias+
            "&i="+serv.itinerario.inicioDeServicio+
            "&f="+serv.itinerario.finDeServicio+
            "&c="+JSON.stringify(combinaciones)+
            "&cA="+JSON.stringify(conceptosAdicionales)+
            "&tv="+cotizacion.tipoDeVenta+
            "&key="+cotizacion.$key;
*/
        /*let url = "https://trosten.azurewebsites.net/#/cotizacion/"+cotizacion.$key+"?id="+cotizacion.idTrosten+
            "&o="+serv.origen.alias+
            "&d="+serv.destino.alias+
            "&i="+serv.itinerario.inicioDeServicio+
            "&f="+serv.itinerario.finDeServicio+
            "&c="+JSON.stringify(combinaciones)+
            "&cA="+JSON.stringify(conceptosAdicionales)+
            "&tv="+cotizacion.tipoDeVenta+
            "&key="+cotizacion.$key;
*/
        /*let obj = {
            idTrosten: cotizacion.idTrosten,
            emailReceptor : contacto.email,
            nombreReceptor: contacto.nombre,
            tipoViaje: cotizacion.tipoDeVenta,
            linkPdf:url,
        };

         const obj = {
         idTrosten: cotizacion.idTrosten,
         emailReceptor : contacto.email,
         nombreReceptor: contacto.nombre,
         tipoViaje: cotizacion.tipoDeVenta,
         //linkPdf:url,
         };
*/

        let url = "https://operacion.trosten.com/#/cotizacion/"+cotizacion.$key;

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'idTrosten=' + cotizacion.idTrosten +'&emailReceptor='+contacto.email+'&nombreReceptor='+contacto.nombre+'&tipoViaje='+cotizacion.tipoDeVenta+'&linkPdf='+url;

        //return this.http.post('https://us-central1-trosten-efcb3.cloudfunctions.net/app/enviar-email-cliente', body);
        return this.http.post('https://operacion.trosten.com/pdf-service/email_cotizacion/sendEmailPDF.php', body,{headers});

    }

    /*
    Adjuntar Archivo
    */
    archivoAdjunto(Archivo,referencia, id){
        return this.firebaseStorage.child('archivosAdjuntos/' +referencia+'/'+id+'/'+ Archivo.name).put(Archivo)
    }

    /**
     * Marca la cotizaciÃ³n como enviada para el cliente
     * @param cotizacion
     */
    public marcarCotizacionComoEnviada(cotizacion:any){
        // Actualiza el estatus de "Enviado al cliente"
        let multipath = {};
        multipath['cotizaciones/' + cotizacion.$key + '/fueEnviada/'] = true;
        multipath['cotizacionesPorUsuario/' + cotizacion.usuarioQueCotizo + '/' + cotizacion.$key + '/fueEnviada/'] = true;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(cotizacion.$key),{fueEnviada:true})

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    /**
     * Marca la cotizaciÃ³n como leida por el cliente
     * @param idCotizacion
     * @param usuarioQueCotizo
     */
    public marcarCotizacionComoLeida(idCotizacion:string, usuarioQueCotizo:string){
        // Actualiza el estatus de "Leida por el cliente"
        let multipath = {};
        multipath['cotizaciones/' + idCotizacion + '/fueLeida/'] = true;
        if(usuarioQueCotizo!="")
        multipath['cotizacionesPorUsuario/' + usuarioQueCotizo + '/' + idCotizacion + '/fueLeida/'] = true;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{fueLeida:true})

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    /**
     * Obtiene el Ãºltimo nÃºmero de las cotizaciones creadas
     */
    public obtenerContadorDeCotizaciones(){
        return this.afDB.object('contadores/numeroCotizaciones');
    }

    /**
     * Edita el alias de origen y destino de la cotizaciÃ³n
     * @param idCotizacion ID de la cotizacion de Firebase
     * @param usuarioQueCotizo ID (Firebase) de la persona que creÃ³ la cotizaciÃ³n
     * @param alias Objeto con dos propiedades: Origen y Destino con un string en cada uno
     */
    public editarMetodoCotizacion(idCotizacion:string, usuarioQueCotizo:string, metodo:any):Promise<any> {
        let multipath:any = {};
        multipath[`cotizaciones/${idCotizacion}/metodoDeCotizacion/`] = metodo;
        multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/metodoDeCotizacion/`] = metodo;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{metodoDeCotizacion:metodo})
        let promiseRealtimeDB;
        let promiseFirestore;
        // Checa que el objeto tenga propiedades para que realice la actualizaciÃ³n
        if (Object.keys(multipath).length === 0 && multipath.constructor === Object) {
            promiseFirestore = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
            promiseRealtimeDB = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
        } else {
            promiseFirestore = batch.commit();
            promiseRealtimeDB = this.afDB.object('/').update(multipath);
        }
        
        


        return Promise.all([promiseRealtimeDB,promiseFirestore]);

        
    }
    public editarTipoVenta(idCotizacion:string, usuarioQueCotizo:string, tipo:any):Promise<any> {
        let multipath:any = {};
        multipath[`cotizaciones/${idCotizacion}/tipoDeVenta/`] = tipo;
        multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/tipoDeVenta/`] = tipo;

        let promiseRealtimeDB;
        let promiseFirestore;
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{tipoDeVenta:tipo})
        // Checa que el objeto tenga propiedades para que realice la actualizaciÃ³n
        if (Object.keys(multipath).length === 0 && multipath.constructor === Object) {
            promiseFirestore = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
            promiseRealtimeDB = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
        } else {
            promiseFirestore = batch.commit();
            promiseRealtimeDB = this.afDB.object('/').update(multipath);
        }
        
        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }
    public editarAlias(idCotizacion:string, usuarioQueCotizo:string, alias:any):Promise<any> {
        let multipath:any = {};

        let promiseRealtimeDB;
        let promiseFirestore;
        let batch = this.afs.firestore.batch();

        // Realiza una limpieza de los campos que se hayan introducido y los coloca en
        if (alias.hasOwnProperty('origen') && alias.origen.trim().length > 0){
            alias.origen = alias.origen.trim();
            multipath[`cotizaciones/${idCotizacion}/aliasOrigen/`] = alias.origen;
            multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/aliasOrigen/`] = alias.origen;

            batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{aliasOrigen:alias.origen})
        }

        if (alias.hasOwnProperty('destino') && alias.destino.trim().length > 0){
            alias.destino = alias.destino.trim();
            multipath[`cotizaciones/${idCotizacion}/aliasDestino/`] = alias.destino;
            multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/aliasDestino/`] = alias.destino;

            batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{aliasDestino:alias.destino})
        }
        
        // Checa que el objeto tenga propiedades para que realice la actualizaciÃ³n
        if (Object.keys(multipath).length === 0 && multipath.constructor === Object) {
            promiseFirestore = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
            promiseRealtimeDB = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
        } else {
            promiseFirestore = batch.commit();
            promiseRealtimeDB = this.afDB.object('/').update(multipath);
        }
        
        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }
    public editarIdNegocioHubspot(idCotizacion:string,usuarioQueCotizo:string, idHubSpot: string):Promise<any> {
        let multipath:any = {};
        multipath[`cotizaciones/${idCotizacion}/idNegocioHubSpot/`] = idHubSpot;
        multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/idNegocioHubSpot/`] = idHubSpot;

        let promiseRealtimeDB;
        let promiseFirestore;
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{idNegocioHubSpot:idHubSpot})
        // Checa que el objeto tenga propiedades para que realice la actualizaciÃ³n
        if (Object.keys(multipath).length === 0 && multipath.constructor === Object) {
            promiseFirestore = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
            promiseRealtimeDB = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
        } else {
            promiseFirestore = batch.commit();
            promiseRealtimeDB = this.afDB.object('/').update(multipath);
        }
        
        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }
    /**
     * TRae de la BD las cotizaciones entre 2 fechas
     * @param fechaInicio
     * @param FechaFin
     */
    public obtenerCotizacionesPorFecha(fechaInicio, fechaFin){
        return this.afDB.list('cotizaciones', ref => ref.orderByChild('fechaDeCreacion').startAt(fechaInicio).endAt(fechaFin));
    }

    /**
     * Actualiza el contacto principal que solicitÃ³ la cotizaciÃ³n
     */
    public actualizarContactoQueCotizo(idCotizacion:string, usuarioQueCotizo:string, idContacto:string):Promise<any>{
        let multipath = {};
        multipath[`cotizaciones/${idCotizacion}/contactoQueCotizo/`] = idContacto;
        multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/contactoQueCotizo/`] = idContacto;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{contactoQueCotizo:idContacto})

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    /**
     * Actualizar referencia de empleado
     */
    public actualizarReferenciaDeEmpleado(idCotizacion:string, usuarioQueCotizo:string, idEmpleado:string):Promise<any>{
        let multipath = {};
        multipath[`cotizaciones/${idCotizacion}/referenciaDeEmpleado/`] = idEmpleado;
        multipath[`cotizacionesPorUsuario/${usuarioQueCotizo}/${idCotizacion}/referenciaDeEmpleado/`] = idEmpleado;
        
        
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{referenciaDeEmpleado:idEmpleado})

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    public obtnerCotizacionesAntiguasPorCliente(cliente){
        return this.afs.collection('cotizacionesRealizadas',ref=>ref.where('cliente','==',cliente).orderBy('fechaDeCreacion','asc'))
    }

    public reutilizarCotizacion(id, cotizacion){
        let multipath = {};
            cotizacion['fechaDeCreacion']=Date.now();
            multipath['cotizaciones/'+id+'/'] = cotizacion;
            multipath['cotizacionesPorUsuario/'+cotizacion.usuarioQueCotizo+'/'+id+'/'] = cotizacion;

            let batch = this.afs.firestore.batch();
            batch.update(this.afs.firestore.collection('cotizaciones').doc(id),cotizacion)


            let promiseRealtimeDB = this.afDB.object('/').update(multipath);
            let promiseFirestore = batch.commit();


        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    public eliminarCotizacionAntigua(id){
        return this.afs.collection('cotizacionesRealizadas').doc(id).delete()
    }


    public obtenerTodas(){
        return this.afDB.list('/pendientesPorResponsable/');
    }
    public eliminarCadaUna(idCotizacion)
    {
        return this.afDB.object('/pendientesPorResponsable/' + idCotizacion).remove();
    }


    public traerInfoSistemaAdmin()
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'fhrtbxdbtrbrt=autorizado';

        return this.http.post('https://operacion.trosten.com/admin-exec/php/admin/Puntos_Origen/getPuntosOrigen.php', body,{headers});

    }

    public getDisponibilidadPorTipoUnidad(tipoUnidad,fechaInicio,daysBeforeAndAfter,zona)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'fhrtbxdbtrbrt=autorizado&tipoDeUnidad='+tipoUnidad+'&f_i='+fechaInicio+'&daysBeforeAndAfter='+daysBeforeAndAfter+'&zona='+zona;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getDisponibilidadPorTipoDeUnidad.php', body,{headers});
    }

    public eliminarCotizacionDeTabla(key_cotizacion,data_cotizacion,tabla){
        let multipathUpdate = {};
        multipathUpdate['/cotizaciones'+tabla+'/' + key_cotizacion] = null;
        multipathUpdate['/cotizacionesPorUsuario'+tabla+'/' + data_cotizacion['usuarioQueCotizo'] + '/' + key_cotizacion] = null;

        return Promise.all([this.afDB.object('/').update(multipathUpdate), key_cotizacion]);
    }

    public reasignarCotizacion(idCotizacion:string, data_cotizacion, newCliente:any):Promise<any> {
        let multipath:any = {};
        multipath[`cotizaciones/${idCotizacion}/cliente/`] = newCliente;
        multipath[`cotizacionesPorUsuario/${data_cotizacion['usuarioQueCotizo']}/${idCotizacion}/cliente/`] = newCliente;

        let promiseRealtimeDB;
        let promiseFirestore;
        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion),{cliente:newCliente})
        // Checa que el objeto tenga propiedades para que realice la actualizaciÃ³n
        if (Object.keys(multipath).length === 0 && multipath.constructor === Object) {
            promiseFirestore = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
            promiseRealtimeDB = Promise.reject(new Error('Los campos estÃ¡n vacÃ­os'));
        } else {
            promiseFirestore = batch.commit();
            promiseRealtimeDB = this.afDB.object('/').update(multipath);
        }
        
        return Promise.all([promiseRealtimeDB,promiseFirestore]);
    }

    public crearSolicitudDisponibilidad(key:string, objSolicitud:any,usuario:any,comentariosVentas, prioridad,indicaciones) {
    
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'usuario_solicitante='+encodeURIComponent(usuario)+
            '&comentarios_ventas='+encodeURIComponent(comentariosVentas)+
            '&inicioDeServicio='+objSolicitud.inicioDeServicio+
            '&key_cotizacion='+encodeURIComponent(key)+
            '&prioridad='+encodeURIComponent(prioridad)+
            '&info_cotizacion='+encodeURIComponent(JSON.stringify(objSolicitud))+
            '&indicacionesEspeciales='+encodeURIComponent(indicaciones);
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/agregarSolicitudDisponibilidad.php', body,{headers});
    }
    public cambiarPrioVentas(id_solicitud:any, prioridad:any)
    {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'id_solicitud='+id_solicitud+
            '&prio_ventas='+prioridad;
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/cambiarPrioVentas.php', body,{headers});
    }
    public cambiarEstatusVentas( estatus:any,key:string,razon) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key='+key+
            '&estatus='+estatus+
            '&razon='+razon;
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/cambiarEstatusVentas.php', body,{headers});
    }

    public getSolicitudesDisponibilidadCotizacion(key:string) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key_cotizacion='+key;
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/getSolicitudesPorKey.php', body,{headers});
    }
    public marcarSolicitudComoExpirada(key:string) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'id_solicitud_disponibilidad='+key;
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/marcarSolicitudComoExpirada.php', body,{headers});
    }
    public crearSolicitudDisponibilidadConfirmaciones(idTrosten:string,objConfi:any,usuario:any,comentariosVentas, prioridad,datosVersion) {
    
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'usuario_solicitante='+encodeURIComponent(usuario)+
            '&comentarios_ventas='+encodeURIComponent(comentariosVentas)+
            '&idTrosten='+encodeURIComponent(idTrosten)+
            '&prioridad='+encodeURIComponent(prioridad)+
            '&info_confirmacion='+encodeURIComponent(JSON.stringify(objConfi))+
            '&datosVersion='+encodeURIComponent(JSON.stringify(datosVersion));
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/DisponibilidadConfirmaciones/agregarSolicitudDisponibilidad.php', body,{headers});
    }
    public cancelarSolicitudDisponibilidad(key:string) {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = 'key='+key;
            return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Disponibilidad/cancelarSolicitudDisponibilidad.php', body,{headers});
    }
    public obtenerCotizacionesEntreFechasFS(fechaInicio, fechaFin){
        return this.afs.collection("cotizaciones", ref => ref.where("fechaDeCreacion", ">", 1735718401000).orderBy("fechaDeCreacion", "asc"));
    }

    public obtenerCotizacionesSinHubspotFS(month: number, year: number) {
        // Calculate start and end timestamps for the given month
        const startDate = new Date(year, month - 1, 1, 0, 0, 0, 0);
        const endDate = new Date(year, month, 0, 23, 59, 59, 999); // Last day of month

        const startTimestamp = startDate.getTime();
        const endTimestamp = endDate.getTime();

        return this.afs.collection("cotizaciones", ref =>
            ref.where("fechaDeCreacion", ">=", startTimestamp)
               .where("fechaDeCreacion", "<=", endTimestamp)
               .orderBy("fechaDeCreacion", "desc")
        );
    }

    
    public actualizarEventoIdCotizacion(idCotizacion:string, usuarioQueCotizo:string, eventoId:string):Promise<any> {
        console.log('[CotizacionesService] actualizarEventoIdCotizacion', { idCotizacion, usuarioQueCotizo, eventoId });
        let multipath:any = {};
        multipath['cotizaciones/' + idCotizacion + '/eventoId/'] = eventoId;
        multipath['cotizacionesPorUsuario/' + usuarioQueCotizo + '/' + idCotizacion + '/eventoId/'] = eventoId;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion), { eventoId: eventoId });

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();
        return Promise.all([promiseRealtimeDB, promiseFirestore]);
    }

    public limpiarEventoIdCotizacion(idCotizacion:string, usuarioQueCotizo:string):Promise<any> {
        console.log('[CotizacionesService] limpiarEventoIdCotizacion', { idCotizacion, usuarioQueCotizo });
        let multipath:any = {};
        multipath['cotizaciones/' + idCotizacion + '/eventoId/'] = null;
        multipath['cotizacionesPorUsuario/' + usuarioQueCotizo + '/' + idCotizacion + '/eventoId/'] = null;

        let batch = this.afs.firestore.batch();
        batch.update(this.afs.firestore.collection('cotizaciones').doc(idCotizacion), { eventoId: null });

        let promiseRealtimeDB = this.afDB.object('/').update(multipath);
        let promiseFirestore = batch.commit();
        return Promise.all([promiseRealtimeDB, promiseFirestore]);
    }
    public getConsideracionesAdicionales() {
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const body = '';
        return this.http.post('https://operacion.trosten.com/admin-exec/php/admin/ConsideracionesAdicionales/getConsideracionesAdicionales.php', body, {headers});
    }
}






// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/cotizaciones.service.ts